module.exports = __webpack_public_path__ + "static/media/nb_tidepool_bg.e383021e.jpg";